<script>
  import 'swiper/css'
  import 'swiper/css/grid'
  import 'swiper/css/pagination'
// prettier-ignore
  import About from './components/_about.section.svelte'
  import Blog from './components/_blog.section.svelte'
  import Contact from './components/_contact.section.svelte'
  import Hero from './components/_hero.section.svelte'
  import Service from './components/_service.section.svelte'
  // import Portfolio from './components/_portfolio.section.svelte'
</script>

<Hero />
<Service />
<!-- <Portfolio /> -->
<About />
<Contact />
<Blog />
